export default [
  '/flags/country-ad.svg',
  '/flags/country-ae.svg',
  '/flags/country-af.svg',
  '/flags/country-ag.svg',
  '/flags/country-ai.svg',
  '/flags/country-al.svg',
  '/flags/country-am.svg',
  '/flags/country-ao.svg',
  '/flags/country-aq.svg',
  '/flags/country-ar.svg',
  '/flags/country-as.svg',
  '/flags/country-at.svg',
  '/flags/country-au.svg',
  '/flags/country-aw.svg',
  '/flags/country-ax.svg',
  '/flags/country-az.svg',
  '/flags/country-ba.svg',
  '/flags/country-bb.svg',
  '/flags/country-bd.svg',
  '/flags/country-be.svg',
  '/flags/country-bf.svg',
  '/flags/country-bg.svg',
  '/flags/country-bh.svg',
  '/flags/country-bi.svg',
  '/flags/country-bj.svg',
  '/flags/country-bl.svg',
  '/flags/country-bm.svg',
  '/flags/country-bn.svg',
  '/flags/country-bo.svg',
  '/flags/country-bq.svg',
  '/flags/country-br.svg',
  '/flags/country-bs.svg',
  '/flags/country-bt.svg',
  '/flags/country-bv.svg',
  '/flags/country-bw.svg',
  '/flags/country-by.svg',
  '/flags/country-bz.svg',
  '/flags/country-ca.svg',
  '/flags/country-cc.svg',
  '/flags/country-cd.svg',
  '/flags/country-cf.svg',
  '/flags/country-cg.svg',
  '/flags/country-ch.svg',
  '/flags/country-ci.svg',
  '/flags/country-ck.svg',
  '/flags/country-cl.svg',
  '/flags/country-cm.svg',
  '/flags/country-cn.svg',
  '/flags/country-co.svg',
  '/flags/country-cp.svg',
  '/flags/country-cr.svg',
  '/flags/country-cu.svg',
  '/flags/country-cv.svg',
  '/flags/country-cw.svg',
  '/flags/country-cx.svg',
  '/flags/country-cy.svg',
  '/flags/country-cz.svg',
  '/flags/country-de.svg',
  '/flags/country-dg.svg',
  '/flags/country-dj.svg',
  '/flags/country-dk.svg',
  '/flags/country-dm.svg',
  '/flags/country-do.svg',
  '/flags/country-dz.svg',
  '/flags/country-ea.svg',
  '/flags/country-ec.svg',
  '/flags/country-ee.svg',
  '/flags/country-eg.svg',
  '/flags/country-eh.svg',
  '/flags/country-er.svg',
  '/flags/country-es.svg',
  '/flags/country-et.svg',
  '/flags/country-eu.svg',
  '/flags/country-fi.svg',
  '/flags/country-fj.svg',
  '/flags/country-fk.svg',
  '/flags/country-fm.svg',
  '/flags/country-fo.svg',
  '/flags/country-fr.svg',
  '/flags/country-ga.svg',
  '/flags/country-gb.svg',
  '/flags/country-gd.svg',
  '/flags/country-ge.svg',
  '/flags/country-gf.svg',
  '/flags/country-gg.svg',
  '/flags/country-gh.svg',
  '/flags/country-gi.svg',
  '/flags/country-gl.svg',
  '/flags/country-gm.svg',
  '/flags/country-gn.svg',
  '/flags/country-gp.svg',
  '/flags/country-gq.svg',
  '/flags/country-gr.svg',
  '/flags/country-gs.svg',
  '/flags/country-gt.svg',
  '/flags/country-gu.svg',
  '/flags/country-gw.svg',
  '/flags/country-gy.svg',
  '/flags/country-hk.svg',
  '/flags/country-hm.svg',
  '/flags/country-hn.svg',
  '/flags/country-hr.svg',
  '/flags/country-ht.svg',
  '/flags/country-hu.svg',
  '/flags/country-ic.svg',
  '/flags/country-id.svg',
  '/flags/country-ie.svg',
  '/flags/country-il.svg',
  '/flags/country-im.svg',
  '/flags/country-in.svg',
  '/flags/country-io.svg',
  '/flags/country-iq.svg',
  '/flags/country-ir.svg',
  '/flags/country-is.svg',
  '/flags/country-it.svg',
  '/flags/country-je.svg',
  '/flags/country-jm.svg',
  '/flags/country-jo.svg',
  '/flags/country-jp.svg',
  '/flags/country-ke.svg',
  '/flags/country-kg.svg',
  '/flags/country-kh.svg',
  '/flags/country-ki.svg',
  '/flags/country-km.svg',
  '/flags/country-kn.svg',
  '/flags/country-kp.svg',
  '/flags/country-kr.svg',
  '/flags/country-kw.svg',
  '/flags/country-ky.svg',
  '/flags/country-kz.svg',
  '/flags/country-la.svg',
  '/flags/country-lb.svg',
  '/flags/country-lc.svg',
  '/flags/country-li.svg',
  '/flags/country-lk.svg',
  '/flags/country-lr.svg',
  '/flags/country-ls.svg',
  '/flags/country-lt.svg',
  '/flags/country-lu.svg',
  '/flags/country-lv.svg',
  '/flags/country-ly.svg',
  '/flags/country-ma.svg',
  '/flags/country-mc.svg',
  '/flags/country-md.svg',
  '/flags/country-me.svg',
  '/flags/country-mf.svg',
  '/flags/country-mg.svg',
  '/flags/country-mh.svg',
  '/flags/country-mk.svg',
  '/flags/country-ml.svg',
  '/flags/country-mm.svg',
  '/flags/country-mn.svg',
  '/flags/country-mo.svg',
  '/flags/country-mp.svg',
  '/flags/country-mq.svg',
  '/flags/country-mr.svg',
  '/flags/country-ms.svg',
  '/flags/country-mt.svg',
  '/flags/country-mu.svg',
  '/flags/country-mv.svg',
  '/flags/country-mw.svg',
  '/flags/country-mx.svg',
  '/flags/country-my.svg',
  '/flags/country-mz.svg',
  '/flags/country-na.svg',
  '/flags/country-nc.svg',
  '/flags/country-ne.svg',
  '/flags/country-nf.svg',
  '/flags/country-ng.svg',
  '/flags/country-ni.svg',
  '/flags/country-nl.svg',
  '/flags/country-no.svg',
  '/flags/country-np.svg',
  '/flags/country-nr.svg',
  '/flags/country-nu.svg',
  '/flags/country-nz.svg',
  '/flags/country-om.svg',
  '/flags/country-pa.svg',
  '/flags/country-pe.svg',
  '/flags/country-pf.svg',
  '/flags/country-pg.svg',
  '/flags/country-ph.svg',
  '/flags/country-pk.svg',
  '/flags/country-pl.svg',
  '/flags/country-pm.svg',
  '/flags/country-pn.svg',
  '/flags/country-pr.svg',
  '/flags/country-ps.svg',
  '/flags/country-pt.svg',
  '/flags/country-pw.svg',
  '/flags/country-py.svg',
  '/flags/country-qa.svg',
  '/flags/country-re.svg',
  '/flags/country-ro.svg',
  '/flags/country-rs.svg',
  '/flags/country-ru.svg',
  '/flags/country-rw.svg',
  '/flags/country-sa.svg',
  '/flags/country-sb.svg',
  '/flags/country-sc.svg',
  '/flags/country-sd.svg',
  '/flags/country-se.svg',
  '/flags/country-sg.svg',
  '/flags/country-sh.svg',
  '/flags/country-sh-ac.svg',
  '/flags/country-sh-ta.svg',
  '/flags/country-si.svg',
  '/flags/country-sj.svg',
  '/flags/country-sk.svg',
  '/flags/country-sl.svg',
  '/flags/country-sm.svg',
  '/flags/country-sn.svg',
  '/flags/country-so.svg',
  '/flags/country-sr.svg',
  '/flags/country-ss.svg',
  '/flags/country-st.svg',
  '/flags/country-sv.svg',
  '/flags/country-sx.svg',
  '/flags/country-sy.svg',
  '/flags/country-sz.svg',
  '/flags/country-tc.svg',
  '/flags/country-td.svg',
  '/flags/country-tf.svg',
  '/flags/country-tg.svg',
  '/flags/country-th.svg',
  '/flags/country-tj.svg',
  '/flags/country-tk.svg',
  '/flags/country-tl.svg',
  '/flags/country-tm.svg',
  '/flags/country-tn.svg',
  '/flags/country-to.svg',
  '/flags/country-tr.svg',
  '/flags/country-tt.svg',
  '/flags/country-tv.svg',
  '/flags/country-tw.svg',
  '/flags/country-tz.svg',
  '/flags/country-ua.svg',
  '/flags/country-ug.svg',
  '/flags/country-um.svg',
  '/flags/country-united_nations.svg',
  '/flags/country-us.svg',
  '/flags/country-uy.svg',
  '/flags/country-uz.svg',
  '/flags/country-va.svg',
  '/flags/country-vc.svg',
  '/flags/country-ve.svg',
  '/flags/country-vg.svg',
  '/flags/country-vi.svg',
  '/flags/country-vn.svg',
  '/flags/country-vu.svg',
  '/flags/country-wf.svg',
  '/flags/country-ws.svg',
  '/flags/country-xk.svg',
  '/flags/country-xx.svg',
  '/flags/country-ye.svg',
  '/flags/country-yt.svg',
  '/flags/country-za.svg',
  '/flags/country-zm.svg',
  '/flags/country-zw.svg',
] as string[];